import React, { useState } from 'react';
import './CourseEnrollForm.css';

const SOURCE_OPTIONS = [
  'Friend / Family Referral',
  'School / College Recommendation',
  'Google Search',
  'Social Media (Instagram / Facebook)',
  'YouTube',
  'LinkedIn',
  'WhatsApp',
  'Newspaper / Magazine',
  'Event / Hackathon',
  'ibots Website',
  'Other',
];

const errStyle = { color: '#e8394d', fontSize: '11px', marginTop: '4px' };

function CourseEnrollForm({ courseName, onClose, isCollege = false, isWorkshop = false, isVAC = false, programme = '' }) {
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    fullName: '', phone: '', email: '', institution: '',
    grade: '', department: '', timing: '', customTiming: '',
    customInstitution: '', studentCount: '', designation: '',
    mode: '', questions: '', source: '', customSource: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const handleSubmit = async () => {
    const newErrors = {};
    if (!formData.fullName) newErrors.fullName = 'Full name is required';
    if (!formData.phone) newErrors.phone = 'Phone number is required';
    if (!formData.institution) newErrors.institution = 'Institution is required';
    if (!formData.source) newErrors.source = 'Please tell us how you heard about ibots';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setTimeout(() => {
        const firstError = document.querySelector('.error-field');
        if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);
      return;
    }

    const gradeMap = {
      'grade3':'Grade 3','grade4':'Grade 4','grade5':'Grade 5',
      'grade6':'Grade 6','grade7':'Grade 7','grade8':'Grade 8',
      'grade9':'Grade 9','grade10':'Grade 10','grade11':'Grade 11','grade12':'Grade 12',
      'year1':'1st Year','year2':'2nd Year','year3':'3rd Year','year4':'4th Year',
      'pg1':'PG - 1st Year','pg2':'PG - 2nd Year',
    };

    const timingMap = {
      'weekend-morning':   'Weekend Morning (9 AM - 11 AM)',
      'weekend-afternoon': 'Weekend Afternoon (2 PM - 4 PM)',
      'weekday-evening':   'Weekday Evening (6 PM - 8 PM)',
      'holiday-intensive': 'Holiday Intensive (Daily)',
      'weekday':           'Weekdays',
      'weekend':           'Weekends',
      'holiday':           'Holiday / Semester Break',
      'custom':            'Custom Date',
      'innovators':        'Innovators Programme',
      'camp':              'Seasonal Camp',
      'specialised':       'Specialised Programme',
    };

    const resolvedInstitution = formData.institution === 'other' ? formData.customInstitution : formData.institution;
    const resolvedSource = formData.source === 'Other' ? formData.customSource : formData.source;
    const resolvedGrade = gradeMap[formData.grade] || formData.grade || '';
    const resolvedTiming = timingMap[formData.timing] || formData.customTiming || formData.timing || '';

    const getFormType = () => {
      if (isWorkshop) return 'Workshop - ' + (courseName || '');
      if (isVAC) return 'VAC - ' + (courseName || '');
      if (programme) return programme;
      const t = formData.timing || '';
      if (t === 'innovators') return 'Innovators Programme';
      if (t === 'holiday-intensive') return 'Holiday Intensive';
      if (t === 'camp') return 'Seasonal Camp';
      if (t === 'specialised') return 'Specialised Programme';
      return courseName || (isCollege ? 'College Student' : 'School Student');
    };

    try {
      // Save to main backend
      await fetch('http://localhost:5000/api/enquiry', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name:         formData.fullName,
          type:         isWorkshop || isVAC ? 'College' : isCollege ? 'College' : 'School',
          phone:        formData.phone,
          email:        formData.email,
          institution:  resolvedInstitution,
          grade:        resolvedGrade,
          mode:         formData.mode || 'Offline',
          formType:     isWorkshop ? 'Workshop - ' + (courseName||'') : isVAC ? 'VAC - ' + (courseName||'') : courseName || (isCollege ? 'College Student' : 'School Student'),
          timing:       resolvedTiming,
          department:   formData.department || '',
          designation:  formData.designation || '',
          studentCount: formData.studentCount || '',
          questions:    formData.questions || '',
          source:       resolvedSource,
        }),
      });

      // Save to dashboard backend (separate try/catch so failure doesn't block success)
      try {
        await fetch('http://localhost:5000/api/' + (isWorkshop || isVAC ? 'campus' : 'centre'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name:         formData.fullName,
            type:         isCollege ? 'College' : 'School',
            phone:        formData.phone,
            email:        formData.email,
            institution:  resolvedInstitution,
            grade:        resolvedGrade,
            mode:         formData.mode || 'Offline',
            formType:     getFormType(),
            course:       courseName || '',
            timing:       formData.timing === 'other' ? formData.customTiming : formData.timing || '',
            department:   formData.department || '',
            designation:  formData.designation || '',
            studentCount: formData.studentCount || '',
            questions:    formData.questions || '',
            source:       resolvedSource,
          }),
        });
      } catch (dashErr) {
        console.log('Dashboard sync error:', dashErr);
      }

      setSubmitted(true);
    } catch (error) {
      alert('Something went wrong. Please try again.');
    }
  };

  if (submitted) {
    return (
      <div className="cef__wrapper">
        <div className="cef__inner" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '400px', textAlign: 'center', gap: '16px' }}>
          <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: '#dcfce7', color: '#16a34a', fontSize: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900 }}>✓</div>
          <h2 style={{ color: '#0d2e6e', fontWeight: 900, margin: 0 }}>Thank You for Reaching Out to ibots!</h2>
          <p style={{ color: '#64748b', margin: 0, maxWidth: '300px', lineHeight: '1.6' }}>We have received your enrollment request. Our team will get in touch with you within <strong>24 hours</strong> to confirm your batch and next steps.</p>
          <button className="cef__submit" onClick={onClose}>Close</button>
        </div>
      </div>
    );
  }

  return (
    <div className="cef__wrapper">
      <div className="cef__inner">

        <button className="cef__close" onClick={onClose}>✕</button>

        <h2 className="cef__title">
          {isWorkshop ? 'Workshop Enrollment — ' : 'Enrollment Form — '}
          <span className="cef__title-course">{courseName}</span>
        </h2>

        <div className="cef__form">

          <div className="cef__row">
            <div className="cef__group">
              <label className="cef__label">Full Name *</label>
              <input type="text" name="fullName" value={formData.fullName}
                onChange={handleChange} placeholder="Enter full name" className="cef__input" />
              {errors.fullName && <p style={errStyle} className="error-field">{errors.fullName}</p>}
            </div>
            <div className="cef__group">
              <label className="cef__label">Phone Number *</label>
              <input type="text" name="phone" value={formData.phone}
                onChange={handleChange} placeholder="+91 XXXXX XXXXX" className="cef__input" />
              {errors.phone && <p style={errStyle} className="error-field">{errors.phone}</p>}
            </div>
          </div>

          <div className="cef__row">
            <div className="cef__group">
              <label className="cef__label">Email Address</label>
              <input type="email" name="email" value={formData.email}
                onChange={handleChange} placeholder="you@example.com" className="cef__input" />
            </div>
            <div className="cef__group">
              <label className="cef__label">{isWorkshop ? 'College / Institution Name *' : 'Institution Name *'}</label>
              {isWorkshop ? (
                <input type="text" name="institution" value={formData.institution}
                  onChange={handleChange} placeholder="Enter college name" className="cef__input" />
              ) : (
                <>
                  <select name="institution" value={formData.institution}
                    onChange={handleChange} className="cef__input cef__select">
                    <option value="">Select institution...</option>
                    {isCollege ? (
                      <>
                        <option value="psgtech">PSG College of Technology, Coimbatore</option>
                        <option value="psgarts">PSG College of Arts & Science, Coimbatore</option>
                        <option value="cit">Coimbatore Institute of Technology</option>
                        <option value="kct">Kumaraguru College of Technology</option>
                        <option value="snsce">SNS College of Engineering</option>
                        <option value="snsarts">SNS College of Arts & Science</option>
                        <option value="rathinam">Rathinam College of Arts & Science</option>
                        <option value="karpagamce">Karpagam College of Engineering</option>
                        <option value="skcet">Sri Krishna College of Engineering & Technology</option>
                        <option value="skct">Sri Krishna College of Technology</option>
                        <option value="hindusthan">Hindusthan College of Engineering & Technology</option>
                        <option value="avinashilingam">Avinashilingam Institute for Home Science</option>
                        <option value="other">Other College</option>
                      </>
                    ) : (
                      <>
                        <option value="psg">PSG Public School, Coimbatore</option>
                        <option value="nsn">NSN Memorial Senior Secondary School, Coimbatore</option>
                        <option value="sboa">SBOA School & Junior College, Coimbatore</option>
                        <option value="srikrishna">Sri Krishna International School, Coimbatore</option>
                        <option value="pkr">P.K.R. Jain Higher Secondary School, Coimbatore</option>
                        <option value="camford">The Camford International School, Coimbatore</option>
                        <option value="stanes">Stanes Anglo Indian Higher Secondary School, Coimbatore</option>
                        <option value="grd">GRD Matric Higher Secondary School, Coimbatore</option>
                        <option value="suguna">Suguna Rippon Matriculation Higher Secondary School, Coimbatore</option>
                        <option value="karpagam">Karpagam Matriculation Higher Secondary School, Coimbatore</option>
                        <option value="ramakrishna">Sri Ramakrishna Vidyalaya Matriculation Higher Secondary School, Coimbatore</option>
                        <option value="vidyavikas">Vidya Vikas Matriculation Higher Secondary School, Coimbatore</option>
                        <option value="goodshepherd">Good Shepherd International School, Coimbatore</option>
                        <option value="ssvm">SSVM World School, Coimbatore</option>
                        <option value="bishopcotton">Bishop Cotton Girls Higher Secondary School, Coimbatore</option>
                        <option value="other">Other School</option>
                      </>
                    )}
                  </select>
                  {formData.institution === 'other' && (
                    <input type="text" name="customInstitution" value={formData.customInstitution}
                      onChange={handleChange} placeholder="Type your institution name..."
                      className="cef__input cef__input--mt" />
                  )}
                </>
              )}
              {errors.institution && <p style={errStyle} className="error-field">{errors.institution}</p>}
            </div>
          </div>

          <div className="cef__row">
            <div className="cef__group">
              <label className="cef__label">
                {isWorkshop ? 'Designation / Role' : isVAC ? 'Year of Study *' : isCollege ? 'Year of Study *' : 'Grade / Standard *'}
              </label>
              {isWorkshop ? (
                <input type="text" name="designation" value={formData.designation}
                  onChange={handleChange} placeholder="e.g. HOD, Faculty, Student Coordinator" className="cef__input" />
              ) : isCollege ? (
                <select name="grade" value={formData.grade}
                  onChange={handleChange} className="cef__input cef__select">
                  <option value="">Select...</option>
                  <option value="year1">1st Year</option>
                  <option value="year2">2nd Year</option>
                  <option value="year3">3rd Year</option>
                  <option value="year4">4th Year</option>
                  <option value="pg1">PG - 1st Year</option>
                  <option value="pg2">PG - 2nd Year</option>
                </select>
              ) : (
                <select name="grade" value={formData.grade}
                  onChange={handleChange} className="cef__input cef__select">
                  <option value="">Select grade...</option>
                  <option value="grade3">Grade 3</option>
                  <option value="grade4">Grade 4</option>
                  <option value="grade5">Grade 5</option>
                  <option value="grade6">Grade 6</option>
                  <option value="grade7">Grade 7</option>
                  <option value="grade8">Grade 8</option>
                  <option value="grade9">Grade 9</option>
                </select>
              )}
            </div>
            <div className="cef__group">
              <label className="cef__label">{isWorkshop ? 'Preferred Workshop Date / Period' : 'Preferred Batch Timing'}</label>
              <select name="timing" value={formData.timing}
                onChange={handleChange} className="cef__input cef__select">
                <option value="">Select...</option>
                {isWorkshop ? (
                  <>
                    <option value="weekday">Weekdays</option>
                    <option value="weekend">Weekends</option>
                    <option value="holiday">Holiday / Semester Break</option>
                    <option value="custom">Custom Date (specify in message)</option>
                  </>
                ) : (
                  <>
                    <option value="weekend-morning">Weekend Morning (9 AM - 11 AM)</option>
                    <option value="weekend-afternoon">Weekend Afternoon (2 PM - 4 PM)</option>
                    <option value="weekday-evening">Weekday Evening (6 PM - 8 PM)</option>
                    <option value="holiday-intensive">Holiday Intensive (Daily)</option>
                  </>
                )}
              </select>
              {formData.timing === 'custom' && isWorkshop && (
                <input type="text" name="customTiming" value={formData.customTiming}
                  onChange={handleChange} placeholder="e.g. 15 June 2025 or last week of June..."
                  className="cef__input cef__input--mt" />
              )}
            </div>
          </div>

          {(isCollege || isVAC) && !isWorkshop && (
            <div className="cef__group cef__group--full">
              <label className="cef__label">Department *</label>
              <input type="text" name="department" value={formData.department}
                onChange={handleChange} placeholder="e.g. ECE, CSE, Mechanical, EEE..."
                className="cef__input" />
            </div>
          )}

          {isVAC && (
            <div className="cef__group cef__group--full">
              <label className="cef__label">Designation / Role</label>
              <input type="text" name="designation" value={formData.designation}
                onChange={handleChange} placeholder="e.g. HOD, Faculty, Student Coordinator"
                className="cef__input" />
            </div>
          )}

          {isWorkshop && (
            <div className="cef__group cef__group--full">
              <label className="cef__label">Approximate Student Count *</label>
              <input type="text" name="studentCount" value={formData.studentCount}
                onChange={handleChange} placeholder="e.g. 60 students (minimum 60 required)"
                className="cef__input" />
            </div>
          )}

          {!isWorkshop && (
            <div className="cef__group cef__group--full">
              <label className="cef__label">Select Programme Mode *</label>
              <div className="cef__modes">
                <div className={'cef__mode-card ' + (formData.mode === 'Offline' ? 'cef__mode-card--active' : '')}
                  onClick={() => setFormData({ ...formData, mode: 'Offline' })}>
                  <p className="cef__mode-title"> Offline</p>
                  <p className="cef__mode-desc">All sessions at ibots centre. No extra charges. Kits at centre.</p>
                </div>
                <div className={'cef__mode-card ' + (formData.mode === 'Hybrid' ? 'cef__mode-card--active' : '')}
                  onClick={() => setFormData({ ...formData, mode: 'Hybrid' })}>
                  <p className="cef__mode-title"> Hybrid</p>
                  <p className="cef__mode-desc">Online sessions + DIY kit for home practice. Kit is yours to keep.</p>
                  
                </div>
              </div>
            </div>
          )}

          <div className="cef__group cef__group--full">
            <label className="cef__label">Questions / Requirements</label>
            <textarea name="questions" value={formData.questions} onChange={handleChange}
              placeholder={isWorkshop ? "Any specific requirements, preferred dates, or questions about the workshop..." : "Learning goals, prior experience, or any queries..."}
              className="cef__input cef__textarea" />
          </div>

          <div className="cef__group cef__group--full">
            <label className="cef__label">How did you hear about ibots? *</label>
            <select name="source" value={formData.source}
              onChange={handleChange} className="cef__input cef__select">
              <option value="">Select...</option>
              {SOURCE_OPTIONS.map((s) => (<option key={s} value={s}>{s}</option>))}
            </select>
            {errors.source && <p style={errStyle} className="error-field">{errors.source}</p>}
            {formData.source === 'Other' && (
              <input type="text" name="customSource" value={formData.customSource}
                onChange={handleChange} placeholder="Please tell us how you found us..."
                className="cef__input cef__input--mt" />
            )}
          </div>

          <button className="cef__submit" onClick={handleSubmit}>
            {isWorkshop ? 'Submit Workshop Enrollment →' : 'Submit Enrollment Request →'}
          </button>

        </div>
      </div>
    </div>
  );
}

export default CourseEnrollForm;
